module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedBlack.3a2d841.eot";